import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SERVER_FILES } from '../auth/Configs';
import { getMenuGroups } from '../auth/Menu';
import './Sidebar.css';

const Sidebar = () => {
  const account = useSelector((state) => state.sessionAuth);
  const profile = useSelector((state) => state.userSettings);
  const location = useLocation();
  const [expandedGroups, setExpandedGroups] = useState({});

  useEffect(() => {
    setExpandedGroups({});
  }, [location.pathname]);

  const roles = Array.isArray(account.roles) ? account.roles : [];
  const groups = getMenuGroups({
    sessionId: account.sessionId,
    accessFilters: profile?.accessFilters,
    roles,
  });

  const name = [profile?.nom, profile?.prenoms].filter(Boolean).join(' ') ||
    account.username || account.email || 'Mon compte';
  const initials = [profile?.nom?.charAt(0), profile?.prenoms?.charAt(0)]
    .filter(Boolean).join('').toUpperCase() || name.charAt(0).toUpperCase();
  const role = roles.includes('ROLE_ADMIN') || roles.includes('ROLE_SUPER_ADMIN')
    ? 'Administrateur'
    : roles.includes('ROLE_EDITED')
      ? 'Archiviste'
      : roles.includes('ROLE_ASSIST')
        ? 'Assistant'
        : 'Lecteur';

  const isItemActive = (item) =>
    location.pathname === item.to ||
    (!item.exact && location.pathname.startsWith(`${item.to}/`)) ||
    item.activePaths?.includes(location.pathname) ||
    item.activePrefixes?.some((prefix) => location.pathname.startsWith(prefix));

  return (
    <aside className="profile-sidebar app-sidebar">
      <Link to="/apps/home/user" className="app-sidebar-profile" aria-label="Ouvrir mon profil">
        {profile?.fileUrl ? (
          <img className="app-sidebar-avatar" src={SERVER_FILES + profile.fileUrl} alt="" />
        ) : (
          <span className="app-sidebar-avatar app-sidebar-initials" aria-hidden="true">{initials}</span>
        )}
        <span className="app-sidebar-identity">
          <strong>{name}</strong>
          <small>{role}</small>
        </span>
      </Link>

      <nav className="app-sidebar-nav" aria-label="Navigation de l’application">
        {groups.map((group) => {
          const activeGroup = group.items.some(isItemActive);
          const isExpanded = expandedGroups[group.key] ?? activeGroup;

          return (
            <div className="app-sidebar-group" key={group.key}>
              <div className="app-sidebar-group-heading">
                <span>{group.label}</span>
                <button
                  className="app-sidebar-group-toggle"
                  type="button"
                  aria-label={`${isExpanded ? 'Replier' : 'Déplier'} ${group.label}`}
                  aria-expanded={isExpanded}
                  aria-controls={`app-sidebar-${group.key}`}
                  onClick={() => setExpandedGroups((current) => ({
                    ...current,
                    [group.key]: !isExpanded,
                  }))}
                >
                  <i className={`ri-arrow-${isExpanded ? 'down' : 'right'}-s-line`} aria-hidden="true" />
                </button>
              </div>
              <ul
                className={`app-sidebar-links${isExpanded ? '' : ' is-collapsed'}`}
                id={`app-sidebar-${group.key}`}
              >
                {group.items.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.exact}
                      className={({ isActive }) => `app-sidebar-link${isActive || isItemActive(item) ? ' is-active' : ''}`}
                    >
                      <i className={item.icon} aria-hidden="true" />
                      <span>{item.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </nav>
    </aside>
  );
};

export default React.memo(Sidebar);
